import { useAppSelector } from "@/config/store";
import { Avatar, Card, List, ListItem, ListItemIcon, ListItemText } from "@/components/ui";
import { IEdoCourse } from "@/shared/model/edo-course.model";
import { IEdoTeacher } from "@/shared/model/edo-teacher.model";
import { EntityState } from "@/shared/reducers/reducer.utils";
import axios from "axios";
import { useEffect, useState } from "react";
import { Translate, translate } from "react-jhipster";

const CourseTeachers = () => {
  const { entity: course } = useAppSelector<EntityState<IEdoCourse>>(
    (state) => state.edoCourse
  );
  const [teachers, setTeachers] = useState<IEdoTeacher[]>([]);

  useEffect(() => {
    const getTeachers = async () => {
      const response = await axios.get<{ data: IEdoTeacher[] }>(
        `/courses/${course.id}/teachers`
      );
      setTeachers(response.data.data);
    };
    if (course.id) {
      getTeachers();
    }
  }, [course.id]);

  return (
    <Card className="surface grid h-full grid-rows-[min-content_auto_min-content] overflow-hidden rounded-3xl p-0">
      <div className="border-b border-[var(--color-mockup-border)] bg-[var(--color-surface-secondary)]/50 dark:border-[var(--color-mockup-border)] dark:bg-[var(--color-surface-secondary)]/30">
        <div className="flex flex-wrap items-center justify-between gap-3 p-4">
          <h2 className="font-heading text-heading-3 font-bold text-[var(--color-mockup-text)]">
            {translate("edocendoApp.edoTeacher.home.title")}
          </h2>
        </div>
      </div>
      {teachers && teachers.length > 0 ? (
        <List className="divide-y">
          {teachers.map((teacher) => (
            <ListItem key={teacher.userId} className="flex items-center gap-3 py-3">
              <ListItemIcon>
                <Avatar
                  alt={teacher.user.firstName + " " + teacher.user.lastName}
                  fallback={
                    (teacher.user.firstName?.[0] ?? "") +
                    (teacher.user.lastName?.[0] ?? "")
                  }
                  className="bg-primary/10 text-primary"
                />
              </ListItemIcon>
              <ListItemText
                primary={teacher.user.firstName + " " + teacher.user.lastName}
              />
            </ListItem>
          ))}
        </List>
      ) : (
        <div className="p-4 text-center">
          <p className="text-body text-[var(--color-mockup-text-mid)]">
            <Translate contentKey="edocendoApp.edoTeacher.home.notFound" />
          </p>
        </div>
      )}
    </Card>
  );
};

export default CourseTeachers;
